import CPostItem from "core/components/CPostItem/CPostItem";
import CUser from "core/components/CUser/CUser";
import { memo } from "react";

interface ItemCommunityProps {
  community: any;
}

const ItemCommunity = ({ community }: ItemCommunityProps) => {
  return (
    <div className="bg-white px-4 py-2 mb-2 rounded-t-lg">
      <CUser
        avatar={community?.user?.avatar?.url?.thumbnail}
        name={community?.user?.name || community?.user?.username || ""}
        date={community?.created_at}
        id={community?.user_id}
      />
      <CPostItem
        title={community?.content}
        thumbnail={community?.files[0]?.url?.original}
        item={community}
        likeCount={community?.total_likes}
        type="original"
        commentCount={community?.total_comments}
        shareCount={community?.total_shares}
        id={community?.id}
      />
    </div>
  );
};

export default memo(ItemCommunity);
